import React, { useId } from 'react';

export default function FormInput({
  label,
  value,
  onChange,
  type = 'text',
  autoComplete,
  placeholder,
  id,
  inputClassName = 'commanding-input',
  wrapperClassName = 'auth-field',
  labelClassName = 'auth-field-label'
}: {
  label: string;
  value: string;
  onChange: (next: string) => void;
  type?: string;
  autoComplete?: string;
  placeholder?: string;
  id?: string;
  inputClassName?: string;
  wrapperClassName?: string;
  labelClassName?: string;
}) {
  const generatedId = useId();
  const inputId = id || generatedId;

  return (
    <div className={ wrapperClassName }>
      <label htmlFor={ inputId } className={ labelClassName }>{ label }</label>
      <input
        id={ inputId }
        className={ inputClassName }
        value={ value }
        onChange={ (e) => onChange(e.target.value) }
        type={ type }
        autoComplete={ autoComplete }
        placeholder={ placeholder }
      />
    </div>
  );
}

